console.log("✅ buildComponentSubscribeNewsletterWide loaded successfully!");

import { APP_CONFIG } from '../../js/config.js';
import { appState } from "../../js/state.js";

import { registerEventListenerToAttach } from "../../js/to-attach-event-listener-registry.js";
import { isNodeEnvironment } from "../../js/utils-fetch-data-json.js";




export async function buildComponentSubscribeNewsletterWide() {


    console.log(`🔄 Building Component: buildComponentSubscribeNewsletterWide - lang: ${appState.SiteLanguageCookie}`);

    try {


        const skeleton = await buildPageSkeleton();

        //By calling registerEventListenerToAttach() immediately, you wire up your hydration callback without delaying the paint.

        //registerEventListenerToAttach(async () => initbuildComponentSubscribeNewsletterWide(params));
        registerEventListenerToAttach(initbuildComponentSubscribeNewsletterWide);


        if (!isNodeEnvironment()) return skeleton;

        return await buildActualContent();



        return html;
    } catch (err) {
        console.error("❌ Error building buildComponentSubscribeNewsletterWide:", err);
        return "<div>buildComponentSubscribeNewsletterWide could not be loaded.</div>";
    }
}




export async function buildPageSkeleton() {

    // Top two “featured” cards
    const topCardsSkeletonHtml = `

     <div class="grid-blog-home-bottom-section-card my-fake-image-height-150">
        <div class="my-site-lazy-loading-card">
            <div class="my-site-lazy-loading-card-movement"></div>
        </div>
    </div>

    <br />
    <br />
    <br />

  `;






    const html = `

    <div id="placeholder-buildComponentSubscribeNewsletterWide">
  
   
    <center>

    <div class="myPageMargins">
       

                 ${topCardsSkeletonHtml}
       
    </div>

    </center>


     </div> 
    
   
  `;

    return html;
}


export async function buildActualContent() {



    
    await _initValidationTools();


    // Build the HTML
    let html = `    `;

 
    html += `

     <form id="myDefaultUserForm" novalidate>


      `;
  
    html += `
    
  

    <div class="homepage-Newsletter-Container" >

        <div class="homepage-Newsletter-wrapper">

            <div class="homepage-Newsletter-div-TitleBox">
                <label for="myFormInputIDNewsletterEmail" ID="lblSubscribeToOurNewLetter"> ${_tTexts.keySubscribeToOurNewLetter} </label>
            </div>

            <div class="homepage-Newsletter-div-EmailBox">

                <div class="homepage-Newsletter-div-EmailBox-OverallWrapperSplit50">

                    <div class="homepage-Newsletter-div-EmailBox-Table">
                        <div class="homepage-Newsletter-div-EmailBox-wrapper">

                            <div class="homepage-Newsletter-div-EmailBox-cell-Kite">

                                <img class="sendIconIntext-svg" width="30" height="30" alt="" src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/paperplane.svg" />

                            </div>
                            <div class="homepage-Newsletter-div-EmailBox-cell-Textbox">
                                <input type="text" id="EmailTextBox"  class="input100Email" autocmplete="off" placeholder="Enter your email here..." />
                                <input type="text" name="myFormInputIDNewsletterEmail"  type="email" id="myFormInputIDNewsletterEmail" autocomplete="email" class="homepage-Newsletter-div-EmailBox-TextBox" placeholder="${_tTexts.keyEnterYourEmail}" form-context-field aria-required="true" ${formIsDisabled ? 'disabled' : ''} />


                            </div>




                        </div>
                       <br>
                        <div id="ValidationMessage-NewsletterEmail"></div>
                    </div>

                    <div class="homepage-Newsletter-div-EmailBox-cell-Btn">

                        <button type="submit" id="myButtonbtnSubscribeToNewsLetterWide" class="homepage-Newsletter-div-EmailBox-SendBtn">
                            ${_tTexts.keySend}
                        </button>
                    </div>

                </div>






            </div>



        </div>


        <div class="divSubscribeToNewsletterWideCompletedArea displayNone">

            <div id="btnCloseNewsletterWide" class="close">
            </div>

            <h3 class="subscribedHeading"><label ID="lblsubscribeToNewletterWideSubscribeCompleteMessage"> ${_tTexts.keySubscribeWideSubscribeCompleteMessage} </h3>


        </div>

    </div>
  `;

    html += `

      </form>


      `;



    return html;



}


let formIsDisabled = false; // This will be used to disable the form
let _MySubmitFormIsBusy = false;
let isFirstValidationAttempt = true;
let myFormValidationMessageStore = [];


let _validatorModule;
let _tTexts;
let _tLinks;


async function _initValidationTools() {
    //// load your validator and translator just once
    if (!_validatorModule) {
        _validatorModule = await import(
            /* webpackChunkName: "my-form-validator-service" */
            '../../services/my-form-validator-service.js'
        );
    }


    if (!_tTexts || !_tLinks) {
        const { loadMyTranslationsService } = await import(
            /* webpackChunkName: "translation-service" */
            /* webpackPrefetch: true */
            '../../services/my-translator-service.js'
        );
        ({
            _tempTextTranslator: _tTexts,
            _tempLinksTranslator: _tLinks,
        } = await loadMyTranslationsService(
            appState.SiteLanguageCookie
        ));
    }



}


// placeholder for testing only so can click through to function
const getValidatorModuleX = async () => {

    return await import(
        /* webpackChunkName: "my-form-validator-service" */
        "../../services/my-form-validator-service.js"
    );
};



export async function initbuildComponentSubscribeNewsletterWide() {

    try {
        console.log("✅ buildComponentSubscribeNewsletterWide event listeners attached.");

        const container = document.querySelector("#placeholder-buildComponentSubscribeNewsletterWide");
        if (!container) return;

        //This touches only the <div id="placeholder-…"> subtree. The rest of the page (header, footer, global scripts) is completely untouched, so the browser can preserve layout and styles. *** FYI Only - innerHTML result in the browser reflowing the entire page, which is expensive.
        container.innerHTML = await buildActualContent();



            await setupCloseBtnButtonListeners();
            await setupSubmitButtonListeners();



    } catch (error) {

        console.error("❌ Error attaching event listeners to buildComponentSubscribeNewsletterWide:", error);

    }


}




async function setupCloseBtnButtonListeners() {

    //const closeBtn = document.getElementById('btnCloseNewsletterWide');


    //also add it whole div divSubscribeToNewsletterWideCompletedArea

    const closeBtn = document.querySelector('.divSubscribeToNewsletterWideCompletedArea');

  if (!closeBtn) return;

  const onCloseClick = async () => {
    await handleResetForm();
  };

  closeBtn.removeEventListener('click', onCloseClick);
  closeBtn.addEventListener('click', onCloseClick);
}

async function setupSubmitButtonListeners() {
  //const submitBtn = document.getElementById('myButtonbtnSubscribeToNewsLetterWide');
  //if (!submitBtn) return;

  //const onSubmitClick = async event => {
  //  event.preventDefault();
  //  await handleSubmitForm();
  //};

  //submitBtn.removeEventListener('click', onSubmitClick);
  //  submitBtn.addEventListener('click', onSubmitClick);


    const form = document.getElementById('myDefaultUserForm');
    if (form) {
        form.addEventListener('submit', async (e) => {
            e.preventDefault(); // Prevent browser default
            await HandleSubmitForm(); // Our custom handler
        });
    }


}


async function HandleValidationRequested() {
    await _initValidationTools();

    const { showValidationErrors, showValidationSummary } = await import(
        /* webpackChunkName: "my-form-validator-service-helper" */

        '../../services/my-form-validator-service-helper.js'
    );

    let finalFormIsvalid = true;

    if (isFirstValidationAttempt == true) {
    } else {
        //clear the myFormValidationMessageStore messages array

        myFormValidationMessageStore = [];

        // run each field’s validator
        const results = await Promise.all([
           
            validateFieldNewsletterEmail(),
           
        ]);

        // collect failures
        results.forEach(r => {
            if (!r.ok) {
                myFormValidationMessageStore.push([r.inputID, r.errorDivID, r.msg]);
            }
        });

        // overall valid if no messages
        if (myFormValidationMessageStore.length !== 0) {
            finalFormIsvalid = false;
        }
    }

    await showValidationErrors('myDefaultUserForm', myFormValidationMessageStore);

   // await showValidationSummary('ValidationSummaryDiv', myFormValidationMessageStore);

    return finalFormIsvalid;
}


async function validateFieldNewsletterEmail() {

    const validatorModule = _validatorModule;
    // const validatorModule = await getValidatorModuleX(); // Placeholder here for testing only

    let inputID = 'myFormInputIDNewsletterEmail';
    let errorDivID = 'ValidationMessage-NewsletterEmail';
    const value = document.getElementById(inputID).value.trim();

    let { isValid, errorKey } = await validatorModule.ValidateRequiredEmail(value);

    if (!isValid) {
        return { ok: false, inputID, errorDivID, msg: _tTexts[errorKey] };
    }

    ({ isValid, errorKey } = await validatorModule.ValidateFormatEmail(value));

    if (!isValid) {
        return { ok: false, inputID, errorDivID, msg: _tTexts[errorKey] };
    }

    return { ok: true };
}


async function HandleSubmitForm() {




    const btnSubmit = document.getElementById('myButtonbtnSubscribeToNewsLetterWide');
    try {

        if (_MySubmitFormIsBusy) {
            return;

        } else {
            _MySubmitFormIsBusy = true;
        }

        function waitMinDelay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));

        }

        btnSubmit.classList.add('myloading');
        btnSubmit.disabled = true;

        const delayMin = waitMinDelay(1000); // start timer early



        // load the validator and translator just once
        const { setupAddMyFormModelEditContext } = await import(
            /* webpackChunkName: "my-form-validator-service-helper" */
            '../../services/my-form-validator-service-helper.js'
        );

        //   alert(isFirstValidationAttempt);

        if (isFirstValidationAttempt) {
            await setupAddMyFormModelEditContext('myDefaultUserForm', HandleValidationRequested, 300);
        }

        isFirstValidationAttempt = false;

        // Wait for both delay and validation
        const validationResult = await Promise.allSettled([
            // HandleValidationRequested(),
            delayMin
        ]);

        // const isValid = validationResult[0].status === 'fulfilled' && validationResult[0].value;
        if (await HandleValidationRequested()) {
            console.log('Form is valid');

            await MyProcessValidSubmit();

        }
        else {



        }



    } catch (err) {

        console.error(err);

    } finally {

        _MySubmitFormIsBusy = false;
        btnSubmit.classList.remove('myloading');
        btnSubmit.disabled = false;
    }
}

async function ShowSuccessMessage(){
      // Show success message or perform any other actions
      const wrapper = document.querySelector('.homepage-Newsletter-wrapper');
      const completeDiv = document.querySelector('.divSubscribeToNewsletterWideCompletedArea');
      wrapper.classList.add('displayNone');
      completeDiv.classList.remove('displayNone');
}

async function MyProcessValidSubmit() {


   // alert("MyProcessValidSubmit called!");

    const [{ fetchCreateNewsReaderAsync }] = await Promise.all([
        import(
      /* webpackChunkName:"newsletter-data-service" */ '../../services/data-services/newsletter-data-service.js'
        ),
    ]);


    //_initValidationTools();

    //const [{ navigateTo }] = await Promise.all([
    //    import(
    //  /* webpackChunkName:"router-navigator" */ '../../js/router-navigator.js'
    //    ),
    //]);



    //// Gather form data as a "model" object (like your C# myFormModel)
    const model = {};

    //// --- Basic text inputs ---
   

    model.Email = document.getElementById('myFormInputIDNewsletterEmail').value.trim();

    //model.PasswordHash = document.getElementById('myFormInputIDPassword').value;

    //// --- Phone number and calling code (dropCallingCode1) ---
    //model.PhoneNumber = document.getElementById('myFormInputIDPhoneNumber').value.trim();
    //model.CountryCallingCodeID = document.getElementById('dropdownCallingCode1').value; // note the id is dropdown + ObjectName

    //// --- Referral type (dropdownReferralType) ---
    //model.ReferralTypeID = document.getElementById('dropdownReferralType').value;
    //model.ReferralTypeOtherDetails = document.getElementById('myFormInputIDReferralTypeOther')?.value ?? '';

    //// --- Terms and newsletter ---
    //model.AcceptTermsAndConditions = document.getElementById('ckTermsAndConditions').checked;
    //model.NewsletterOptIn = document.getElementById('ckNewsletter').checked;

    //// --- Optionally, honey pot anti-spam ---
    //model.HoneyPotField = document.getElementById('myFormInputIDHoneyPotField')?.value ?? '';

    //// --- Site/user info from appState ---
    //model.SiteLanguagePreference = appState.SiteLanguageCookie;
    //model.SiteCurrencyPreference = appState.SiteCurrencyCodeCookie;

    //// --- Extra (example for region) ---
    //model.SiteLanguageRegion = navigator.language || "en";
    //model.SendEmailToUserToConfirmEmail = true;

    //// --- Site location URL (if needed) ---
    //model.SiteLocationUrl = window.location.origin;

    //// --- Mapping ReferralTypeID to text (if you want on the client; backend can also do this) ---
    //const referralTypeMap = {
    //    1: "Google Search Engine",
    //    2: "Bing Search Engine",
    //    3: "Facebook",
    //    4: "Instagram",
    //    5: "Friend or Family",
    //    6: "Other",
    //};
    //model.ReferralType = referralTypeMap[model.ReferralTypeID] || "unknown";

    //// --- Now POST this object to your backend ---


    //const validationSummaryDiv = document.getElementById('ValidationSummaryDiv');
    //if (validationSummaryDiv) {
    //    validationSummaryDiv.style.display = 'none'; // Ensure it's visible
    //    validationSummaryDiv.innerText = '';
    //}

    try {




        const result = await fetchCreateNewsReaderAsync(model); // Adjust this function call as needed


        //const result = await response.json();

        if (result.isSuccess) {


           // navigateTo(_tLinks.keyRegistrationComplete);

        }
        //else {

        //    if (validationSummaryDiv) {
        //        validationSummaryDiv.style.display = 'block'; // Ensure it's visible
        //        validationSummaryDiv.innerText = "User Registration Failed - code: " + result.responseCode + " Message:" + result.responseMessage;
        //    }


        //    navigateTo(_tLinks.keyRegistrationComplete);

        //}

       await ShowSuccessMessage();


    } catch (err) {

        //if (validationSummaryDiv) {
        //    validationSummaryDiv.style.display = 'block'; // Ensure it's visible
        //    validationSummaryDiv.innerText = "A network or server error occurred.";
        //}

        //console.error("Registration error:", err);
    }

}



async function handleResetForm() {
    // Reset the form
    const wrapper = document.querySelector('.homepage-Newsletter-wrapper');
    const completeDiv = document.querySelector('.divSubscribeToNewsletterWideCompletedArea');
    const emailInput = document.getElementById('myFormInputIDNewsletterEmail');
    const valMsgDiv = document.querySelector('#ValidationMessage-NewsletterEmail');

    wrapper.classList.remove('displayNone');
    completeDiv.classList.add('displayNone');

    emailInput.value = '';
    valMsgDiv.textContent = '';
    isFirstValidationAttempt = true;


}





//console.log('✅ subscribe-newsletter-wide.js loaded successfully!');

//import { APP_CONFIG } from '../../js/config.js';
//import { appState, setAppStateValueByKey } from '../../js/state.js';
//import { getTextTranslationByKey, loadTextTranslations } from '../../js/translator.js';
//import { saveToLocalStorage, loadFromLocalStorage } from '../../js/utils-local-storage.js';
//import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
//import { buildComponentBreadcrumb } from '../bread-crumbs/bread-crumb.js';
//import {
//  isNodeEnvironment,
//  myFetchJsonContentFromBuildData,
//} from '../../js/utils-fetch-data-json.js';
//import {
//  convertStringAmountToCurrencyAndSignDirectionForLanguage,
//  getCurrencyCultureSymbolOnLeftOrRight,
//} from '../../js/utils-convert-currency.js';
//import {
//  convertNumberStringFromUKFormatToAnyLanguageFormatDouble,
//  convertStringToDecimal,
//  convertStringToInt,
//  convertDateToStringAndFormatForLanguage,
//} from '../../js/utils-convert-numbers.js';
//import { buildComponentCatalogListingImageSlider } from '../catalog/catalog-listing-image-slider.js';

//import { navigateTo } from '../../js/router-navigator.js';

//import {
//  buildComponentBasicBottomPagination,
//  attachEventListenersBasicBottomPagination,
//} from '../pagination-controls/basic-bottom-pagination.js';
//import {
//  buildComponentMainSearchPageFilter,
//  attachEventListenersMainSearchPageFilter,
//} from '../main-search-page-component/main-search-page-component-sidebar-filters.js';

//import { LRUCacheWithTTL } from '../../js/utils-cache.js';
//import { searchPageComponentSharedState } from '../main-search-page-component/main-search-page-component-shared-state.js';
//import { addListenerViaCurrentlyAttachedListenersRegistry } from '../../js/currently-attached-listener-registry.js';

//import { initLinksTranslator } from '../../js/router-routes-manager.js';
//import {
//  fetchGetRelatedBlogArticlesForBlogArticlePageByArticleID,
//  fetchGetRelatedProductsForBlogArticlePageByArticleID,
//  fetchGetBlogArticleForBlogArticlePage,
//} from '../../services/data-services/blog-data-service.js';

//// State
//let _MySubmitFormIsBusy = false;
//let isFirstValidationAttempt = true;
//let messageStore = [];

//const state = { email: '', honey: '' };

//export async function buildComponentSubscribeNewsletterWide() {
//  // console.log(`🔄 Building Component: BasicProductCard - Product Name: ${name}`);

//  try {
//    //  const pageSkeletonHTML = await buildPageSkeleton();

//    const actualContentHTML = await buildActualContent();

//    // const htmlToRender = pageSkeletonHTML;

//    const htmlToRender = actualContentHTML;

//    const html = `
      


//   ${htmlToRender}

      


//        `;

//    // console.log("✅ BasicProductCard built successfully.");

//    // Register event listeners (if any needed in future)
//    //  registerEventListenerToAttach(attachEventListenersBasicProductCard);

//    registerEventListenerToAttach(async () => attachMainEventListenersForThisComponent());

//    return html;
//  } catch (err) {
//    console.error('❌ Error building buildComponentSubscribeNewsletterWide:', err);
//    return '<div>Error loading buildComponentSubscribeNewsletterWide</div>';
//  }
//}

///**
// * Attaches event listeners to the Basic Product Card component
// */
//export async function attachMainEventListenersForThisComponent() {
//  try {
//    // Attach event listeners if needed in the future
//    console.log('✅ buildComponentSubscribeNewsletterWide event listeners attached.');

//    await setupCloseBtnButtonListeners();
//    await setupSubmitButtonListeners();
//  } catch (error) {
//    console.error(
//      '❌ Error attaching event listeners to buildComponentSubscribeNewsletterWide:',
//      error
//    );
//  }
//}



//async function setupCloseBtnButtonListeners() {
//  const closeBtn = document.getElementById('btnCloseNewsletterWide');
//  if (!closeBtn) return;

//  const onCloseClick = async () => {
//    await handleResetForm();
//  };

//  closeBtn.removeEventListener('click', onCloseClick);
//  closeBtn.addEventListener('click', onCloseClick);
//}

//async function setupSubmitButtonListeners() {
//  const submitBtn = document.getElementById('myButtonbtnSubscribeToNewsLetterWide');
//  if (!submitBtn) return;

//  const onSubmitClick = async event => {
//    event.preventDefault();
//    await handleSubmitForm();
//  };

//  submitBtn.removeEventListener('click', onSubmitClick);
//  submitBtn.addEventListener('click', onSubmitClick);
//}

//async function handleSubmitForm() {
//  if (_MySubmitFormIsBusy) return;

//  _MySubmitFormIsBusy = true;

//  const submitBtn = document.getElementById('myButtonbtnSubscribeToNewsLetterWide');
//  submitBtn.classList.add('loading');

//  isFirstValidationAttempt = false;
//  if (handleValidationRequested()) {
//    await processValidSubmit();
//  } else {
//  }

//  //  alert("Submit button clicked!");

//  submitBtn.classList.remove('loading');
//  _MySubmitFormIsBusy = false;
//}

//async function handleValidationRequested() {
//  let isValidResult = true;

//  if (isFirstValidationAttempt == true) {
//  } else {
//    messageStore.length = 0; // Clear previous messages

//    let emailIsValid = true;

//    ////first
//    //var resultValidateRequiredEmail = ValidationExpressionAccess.ValidateRequiredEmail(subscribeToNewsletterFormModel.Email, _myUserIdentityInformationService.SiteLanguageCookie);
//    //if (resultValidateRequiredEmail.Item1 == false) {

//    //        string translatedErrorMessage = resultValidateRequiredEmail.Item2;

//    //    //  string translatedErrorMessage = TranslateSiteControlsAccess.GetSiteControlTextTranslation(resultValidateRequiredEmail.Item2, languageCode, "m", "", "S");

//    //    messageStore.Add(() => subscribeToNewsletterFormModel.Email, translatedErrorMessage);

//    //    emailIsValid = false;

//    //}

//    //if (emailIsValid == true) {

//    //    var resultValidateFormatEmail = ValidationExpressionAccess.ValidateFormatEmail(subscribeToNewsletterFormModel.Email, _myUserIdentityInformationService.SiteLanguageCookie);
//    //    if (resultValidateFormatEmail.Item1 == false) {

//    //            string translatedErrorMessage = resultValidateFormatEmail.Item2;

//    //        // string translatedErrorMessage = TranslateSiteControlsAccess.GetSiteControlTextTranslation(resultValidateFormatEmail.Item2, languageCode, "m", "", "S");

//    //        messageStore.Add(() => subscribeToNewsletterFormModel.Email, translatedErrorMessage);

//    //        emailIsValid = false;

//    //    }

//    //}

//    //first
//    //const emailInput = document.getElementById("TextBoxSubscribeEmail");
//    //const email = emailInput.value.trim();
//    //if (!email) {
//    //    messageStore.push(() => emailInput, "Email is required.");
//    //    emailIsValid = false;
//    //} else {
//    //    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//    //    if (!emailRegex.test(email)) {
//    //        messageStore.push(() => emailInput, "Invalid email format.");
//    //        emailIsValid = false;
//    //    }
//    //}
//  }

//  return isValidResult;
//}

//async function processValidSubmit() {
//  // Process the valid submission here
//  // For example, send the email to your server or perform any other action
//  const emailInput = document.getElementById('TextBoxSubscribeEmail');
//  const email = emailInput.value.trim();
//  // Perform your submission logic here (e.g., send the email to your server)
//  console.log('Email submitted:', email);
//  // Show success message or perform any other actions
//  const wrapper = document.querySelector('.homepage-Newsletter-wrapper');
//  const completeDiv = document.querySelector('.divSubscribeToNewsletterWideCompletedArea');
//  wrapper.classList.add('displayNone');
//  completeDiv.classList.remove('displayNone');
//}

//async function handleResetForm() {
//  // Reset the form
//  const wrapper = document.querySelector('.homepage-Newsletter-wrapper');
//  const completeDiv = document.querySelector('.divSubscribeToNewsletterWideCompletedArea');
//  const emailInput = document.getElementById('TextBoxSubscribeEmail');
//  const valMsgDiv = document.querySelector('.validation-message');

//  wrapper.classList.remove('displayNone');
//  completeDiv.classList.add('displayNone');

//  // emailInput.value = '';
//  // valMsgDiv.textContent = '';
//  // firstValidation = true;
//  // Reset any other state or UI elements as needed
//}

//export async function buildPageSkeleton() {
//  // Top two “featured” cards
//  const topCardsSkeletonHtml = `

//    <div class="homepage-Newsletter-Container">
     
//    <div class="grid-blog-home-bottom-section-card my-fake-image-height-150">
//        <div class="my-site-lazy-loading-card">
//            <div class="my-site-lazy-loading-card-movement"></div>
//        </div>
//    </div>

//    <br />
//    <br />
//    <br />

//     </div>
//  `;

//  const html = `

  
//    ${topCardsSkeletonHtml}

    
   
//  `;

//  return html;
//}

//export async function buildActualContent() {
//  // so it ends up in its own "translation-service" chunk:
//  const { loadMyTranslationsService } = await import(
//    /* webpackChunkName: "my-translator-service" */
//    /* webpackPrefetch: true */
//    '../../services/my-translator-service.js'
//  );

//  // 1) Load translations in parallel (cached after first call)
//  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
//    appState.SiteLanguageCookie
//  );

//  const {
//    keySubscribeToOurNewLetter: lblSubscribeToOurNewLetter,
//    keyEnterYourEmail: lblEnterYourEmail,
//    keySend: lblSend,
//    keySubscribeWideSubscribeCompleteMessage: lblSubscribeWideSubscribeCompleteMessage,
//  } = _tempTextTranslator;

//  const { keyBlog: linkBlog } = _tempLinksTranslator;

//  const html = `


//    <div class="homepage-Newsletter-Container" >

//        <div class="homepage-Newsletter-wrapper">

//            <div class="homepage-Newsletter-div-TitleBox">
//                <label ID="lblSubscribeToOurNewLetter"> ${lblSubscribeToOurNewLetter} </label>
//            </div>

//            <div class="homepage-Newsletter-div-EmailBox">

//                <div class="homepage-Newsletter-div-EmailBox-OverallWrapperSplit50">

//                    <div class="homepage-Newsletter-div-EmailBox-Table">
//                        <div class="homepage-Newsletter-div-EmailBox-wrapper">

//                            <div class="homepage-Newsletter-div-EmailBox-cell-Kite">

//                                <img class="sendIconIntext-svg" width="30" height="30" alt="" src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/paperplane.svg" />

//                            </div>
//                            <div class="homepage-Newsletter-div-EmailBox-cell-Textbox">
//                                <input type="text" id="EmailTextBox"  class="input100Email" autocmplete="off" placeholder="Enter your email here..." />
//                                <input type="text"  id="TextBoxSubscribeEmail" class="homepage-Newsletter-div-EmailBox-TextBox" placeholder="${lblEnterYourEmail}"  />


//                            </div>




//                        </div>
//                        <ValidationMessage For="@(()=> subscribeToNewsletterFormModel.Email)"></ValidationMessage>

//                    </div>

//                    <div class="homepage-Newsletter-div-EmailBox-cell-Btn">

//                        <button type="submit" id="myButtonbtnSubscribeToNewsLetterWide" class="homepage-Newsletter-div-EmailBox-SendBtn">
//                            ${lblSend}
//                        </button>
//                    </div>

//                </div>






//            </div>



//        </div>


//        <div class="divSubscribeToNewsletterWideCompletedArea displayNone">

//            <div id="btnCloseNewsletterWide" class="close">
//            </div>

//            <h3 class="subscribedHeading"><label ID="lblsubscribeToNewletterWideSubscribeCompleteMessage"> ${lblSubscribeWideSubscribeCompleteMessage} </h3>


//        </div>

//    </div>



//    `;

//  return html;
//}

